import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
import RangeSlider from "./assets/rangeSlider";
import Blockly from "blockly";
import "bulma/css/bulma.css";
import "@fortawesome/fontawesome-free/js/all";
import { isElectron } from "./assets/deviceChecker";
import VueAnalysis from "vue-analytics";

window.pyBleHandler = isElectron ? require("./assets/pyBleHandler/pyBleHandler").default : null;
console.log("pyBleHandler", window.pyBleHandler);

window.Blockly = Blockly;
window.whichBoard = "E310";
Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(RangeSlider);
Vue.use(VueAnalysis, {
  id: "UA-61575223-10",
  router,
  autoTracking: false
});
Vue.config.ignoredElements = ["field", "block", "category", "xml", "mutation", "value", "sep"];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
